import { css } from 'styled-components';

export const cardCtaLinkStyles = css`
  color: var(--white);
  background: var(--red);
  font-size: 20px;
  appearance: none;
  cursor: pointer;
  padding: 12px 37px;
  text-align: center;
  display: block;

  &:hover {
    background: var(--crimsonRed);
  }
`;

export const cardCtaLinkWrapperStyles = css`
  padding: 10px 0;
  position: absolute;
  bottom: 20px;

  @media only screen and (max-width: 768px) {
    bottom: 0;
    padding-bottom: 20px;
  }
`;
